<template>
    <article :id="cause.id" class="cause-single cause-item relative">
        <button type="button" class="cause-single__back btn-empty-wrapper absolute" @click="clickHandler">
            <Close icon="back" color-class="text-white"></Close>
        </button>
        <button type="button" class="cause-single__share btn-empty-wrapper absolute" @click="openShare">
            <ShareIcon />
        </button>
        <VideoModel :postVideoUrl="cause.video_url" @showModel="videoModelAction" v-if="showVideoModel" />
        <div class="cause-item__feature" v-if="cause.img !== undefined && cause.img.length > 0">
            <swiper ref="intro" :options="options">
                <swiper-slide v-if="cause.video_url">
                    <div class="cause-item__slide relative" @click="videoModelAction">
                        <img :src="videoImageUrl" loading="lazy"
                            class="absolute top-0 left-0 h-full w-full object-center object-fill" />
                        <img :src="playButton" alt="Thrive" class="absolute left-0 play-buttom" />
                    </div>
                    <!-- <iframe width="100%" height="220px" :src="cause.video_url" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen>
                    </iframe> -->
                </swiper-slide>
                <swiper-slide v-for="(url, index) in getNposJson(cause.img)" :key="index">
                    <div class="cause-item__slide relative">
                        <img loading="lazy" class="absolute top-0 left-0 object-center object-cover h-full w-full"
                            :src="getNposImage(url)" :alt="getNposContent('title') || $t('Cause')" />
                    </div>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
            </swiper>
        </div>
        <div class="cause-item__body">
            <header v-if="cause.title !== undefined && cause.title">
                <h2 class="cause-item__title text-text font-bold text-content">
                    {{ getNposContent("title") }}
                </h2>
            </header>
            <div class="cause-item__content" :class="{ 'full-content': fullContent }"
                v-if="cause.desc !== undefined && cause.desc" v-html="getNposContent('desc')">
                
            </div>
            <div class="cause-item__more w-full text-center relative">
                <button v-if="!fullContent" class="btn-link text-14 text-cause_text" @click="fullContent = true">
                    <fieldset>
                        <legend>{{ $t("More") }}</legend>
                    </fieldset>
                </button>
            </div>
            <Button type="button" :text="$t('Select')" classes="table mx-auto btn-custom"
                :click-handler="saveChoice"></Button>
        </div>
        <footer class="cause-item__footer">
            <div class="cause-item__location px30 py-8">
                <h3 class="text-20 font-bold text-text mb-3 text-left">
                    {{ $t("Locations") }}
                </h3>
                <p class="text-cause_text text-12 tracking-normal pb-6 text-left"
                    v-if="cause.address !== undefined && cause.address">
                    {{ cause.address }}
                </p>
                <ul class="cause-item__phones mb-6" v-if="cause.phone && cause.phone.length">
                    <li class="flex items-center mb-2" v-for="(phone, index) in getNposJson(cause.phone)" :key="index">
                        <span class="cause-item__phone-icon mr-2 icon-color">
                            <PhoneIcon />
                        </span>
                        <a :href="`tel:${phone}`" class="text-12 text-cause_text tracking-normal">{{ phone }}</a>
                    </li>
                </ul>
                <a v-if="cause.link !== undefined && cause.link" :href="cause.link" target="_blank"
                    class="cause-item__web flex text-14 tracking-normal">
                    <span class="cause-item__web-icon mr-3">
                        <svg height="25px" width="25px" data-name="Layer 1" id="Layer_1" viewBox="0 0 128 128"
                            xmlns="http://www.w3.org/2000/svg">
                            <path class="cls-1"
                                d="M64,16A47.5,47.5,0,1,1,16.5,63.5,47.55,47.55,0,0,1,64,16m0-6.5a54,54,0,1,0,54,54,54,54,0,0,0-54-54Z" />
                            <path class="cls-1"
                                d="M65.08,16c2.09,0,5.78,3.66,8.93,11.69,3.71,9.46,5.75,22.18,5.75,35.81s-2,26.35-5.75,35.81c-3.15,8-6.83,11.69-8.93,11.69s-5.78-3.66-8.93-11.69C52.45,89.85,50.4,77.13,50.4,63.5s2-26.35,5.75-35.81C59.31,19.65,63,16,65.08,16m0-6.5c-11.7,0-21.18,24.18-21.18,54s9.48,54,21.18,54,21.18-24.18,21.18-54-9.48-54-21.18-54Z" />
                            <line class="cls-2" x1="17.66" x2="112.5" y1="80.37" y2="80.37" />
                            <line class="cls-2" x1="17.66" x2="112.5" y1="46.62" y2="46.62" />
                        </svg>
                        <!-- <WorldIcon /> -->
                        <!-- <img class="" :srcset="
                            `${$store.state.appUrl}/img/pwa/icons/globalization.svg, ${$store.state.appUrl}/img/pwa/icons/globalization.svg`
                        " :src="`${$store.state.appUrl}/img/pwa/icons/globalization.svg`" alt="Globalization"
                            width="auto" height="auto" /> -->
                    </span>
                    <a v-if="
                        cause.link !== undefined && cause.link
                    " :href="cause.link" target="_blank" class="flex text-14 tracking-normal text-link">
                        {{ cause.link.replace("https://", "") }}
                    </a>
                    <!-- {{ cause.link.replace("https://", "") }} -->
                </a>
            </div>
            <div class="cause-item__map" v-if="cause.location !== undefined && cause.location.length > 0">
                <GoogleMapSingle :location="getNposJson(cause.location)"></GoogleMapSingle>
            </div>
        </footer>

        <template v-if="showSharePopup">
            <div class="share-shape flex fixed top-0 left-0 right-0 bottom-0 h-screen z-10"></div>
            <CauseSingleShare :cause="causeShare" :click-handler="hideShare"></CauseSingleShare>
        </template>
    </article>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import mixins from "../../config/mixins";
import Button from "../UI/Button";
import PhoneIcon from "../Icons/PhoneIcon";
import WorldIcon from "../Icons/WorldIcon";
import GoogleMapSingle from "../GoogleMap/GoogleMapSingle";
import Close from "../UI/Close";
import ShareIcon from "../Icons/ShareIcon";
import CauseSingleShare from "./CauseSingleShare";
import VideoModel from "../../components/Modal/VideoModel.vue";

export default {
    name: "CauseSingle",

    mixins: [mixins.npos],

    components: {
        CauseSingleShare,
        ShareIcon,
        Close,
        GoogleMapSingle,
        WorldIcon,
        PhoneIcon,
        Button,
        Swiper,
        SwiperSlide,
        VideoModel
    },

    directives: {
        swiper: directive,
    },

    props: ["cause", "clickHandler"],

    data: function () {
        return {
            videoImageUrl: "",
            showVideoModel: false,
            fullContent: false,
            showSharePopup: false,
            options: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            },
            causeShare: {
                id: this.cause.id !== undefined ? this.cause.id : 0,
                title:
                    this.cause.title !== undefined
                        ? this.getNposContent("title")
                        : "",
                desc:
                    this.cause.desc !== undefined
                        ? this.getNposContent("desc")
                        : "",
                logo:
                    this.cause.logo !== undefined
                        ? this.getNposImage(this.cause.logo)
                        : "",
            },
        };
    },

    computed: {
        playButton() {
            return `${this.$store.state.appUrl}/img/pwa/login/play-button.svg`
        }
    },

    mounted() {
        if (this.cause.video_url) {
            var res = this.cause.video_url.split("/");
            let video_id = res.slice(-1)[0];
            this.videoImageUrl = `https://img.youtube.com/vi/${video_id}/maxresdefault.jpg`;
        }
        this.saveViewStatistic();
        this.$scrollToTop();
        document.title = this.getNposContent("title");
    },

    methods: {
        openShare: function () {
            this.showSharePopup = true;
        },
        hideShare: function () {
            this.showSharePopup = false;
        },
        saveChoice: function () {
            this.$http
                .post("user/addnpo", { npo_id: this.cause.id })
                .then(data => {
                    if (data && data.status !== undefined && data.status) {
                        this.saveNposChoice(this.getNposContent("title"));
                        if (this.$route.path === "/login") {
                            this.$setState("showGoogleMap", false);
                            this.$setState("showSteps", true);
                            this.$setState("loginActiveStep", "bank");
                            this.$setState("loginSteps", { cause: true });
                            this.$setState("showAppFilters", false);
                        }
                    }
                });
        },
        saveViewStatistic: function () {
            this.$silentHttp.post("user/view_item", {
                type: "npo",
                item_id: this.cause.id,
            });
        },
        videoModelAction: function () {
            if (this.showVideoModel) {
                this.showVideoModel = false
            } else {
                this.showVideoModel = true
            }
        },
    },
};
</script>
